import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'
import { sample, reject, random } from 'lodash'

import micaLogo from '../../assets/mica-logo'
import mgsLogo from '../../assets/mgs2018logo.svg'
import yearLogo from '../../assets/mgs2018year.svg'
import gallery from '../../assets/galleries'

import Logo from '../Logo/Logo'
import Footer from '../Footer/Footer'
import Circle from '../Circle/Circle'
import Slideshow from '../SlideshowAlt/SlideTest'

import {
  Wrapper,
  LogoWrapper,
  Bg,
  ShapeContainer,
  Box,
  Text,
  Top,
  Left,
  Right,
  Tag,
} from './styles.css'
import { colors } from '../../util'

const themes = {
  orangeBlue: {
    color: colors.alt.orange,
    colorAlt: colors.alt.blue,
    colorText: colors.alt.orange,
  },
  orangeGreen: {
    color: colors.alt.orange,
    colorAlt: colors.alt.green,
    colorText: colors.alt.orange,
  },
  orangePink: {
    color: colors.alt.orange,
    colorAlt: colors.alt.pink,
    colorText: colors.alt.orange,
  },
  blueOrange: {
    color: colors.alt.blue,
    colorAlt: colors.alt.orange,
    colorText: colors.alt.blue,
  },
  blueGreen: {
    color: colors.alt.blue,
    colorAlt: colors.alt.green,
    colorText: colors.alt.blue,
  },
  bluePink: {
    color: colors.alt.blue,
    colorAlt: colors.alt.pink,
    colorText: colors.alt.blue,
  },
  greenOrange: {
    color: colors.alt.green,
    colorAlt: colors.alt.orange,
    colorText: colors.alt.green,
  },
  greenBlue: {
    color: colors.alt.green,
    colorAlt: colors.alt.blue,
    colorText: colors.alt.green,
  },
  greenPink: {
    color: colors.alt.green,
    colorAlt: colors.alt.pink,
    colorText: colors.alt.green,
  },
  pinkOrange: {
    color: colors.alt.pink,
    colorAlt: colors.alt.orange,
    colorText: colors.alt.orange,
  },
  pinkBlue: {
    color: colors.alt.pink,
    colorAlt: colors.alt.blue,
    colorText: colors.alt.blue,
  },
  pinkGreen: {
    color: colors.alt.pink,
    colorAlt: colors.alt.green,
    colorText: colors.alt.green,
  },
}

class Splash extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      theme: sample(themes),
      flipX: random(),
      flipY: random(),
      rotate: sample([0, 90, 180, 270]),
      loaded: false,
    }
    this.changeTheme = this.changeTheme.bind(this)
    // set body background
    document.body.style.backgroundColor = this.state.theme.colorAlt
  }

  componentDidMount() {
    this.setState({ loaded: true })
  }

  shouldComponentUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (prevProps.collageArt && prevProps.collageArt.length !== this.props.collageArt.length) {
        return true
      }
      return false
    }
    return false
  }

  changeTheme() {
    const t = reject(themes, this.state.theme)
    const s = sample(t)
    this.setState({ theme: s })
    // document.body.style.backgroundColor = s.colorAlt
  }

  render() {
    const { siteName, collageArt } = this.props
    const { theme, flipX, flipY, rotate, loaded } = this.state
    return (
      <ThemeProvider theme={theme}>
        <Bg>
          <Left>
            <ShapeContainer rotate={rotate} flipX={flipX} flipY={flipY}>
              {gallery}
            </ShapeContainer>
            {siteName && loaded && <Circle bounds="half" />}

            <LogoWrapper pos="top" justifyContent="space-between">
              {siteName && <Logo primary sttc logoSrc={mgsLogo} siteName={siteName} />}
              {micaLogo}
            </LogoWrapper>

            <LogoWrapper pos="bottom" justifyContent="flex-end">
              <Logo right primary sttc logoSrc={yearLogo} siteName={siteName} />
            </LogoWrapper>

            <div style={{ minHeight: '33vh' }} />

            <Wrapper>
              <Box border align="flex-start">
                <Top>Spring / Summer 2019</Top>
                <Tag>Meet the next generation of creative thinkers.</Tag>
                <Text>
                  <bold>MICA GRAD SHOW 2019</bold> showcases the culminating work of more than 180
                  of MICA's graduate students from the College's internationally renowned programs
                  through ground-breaking exhibitions, presentations, public programs and
                  student-curated installations throughout Baltimore City.
                  <br />
                  <br />
                  Join us for a season of innovative and inspiring events and exhibitions featuring
                  the next generation of creative thinkers — artists, designers, filmmakers,
                  educators and curators — as they demonstrate the power and possibility of
                  contemporary art and design.
                </Text>
              </Box>
            </Wrapper>

            <div style={{ minHeight: '66vh' }} />
          </Left>

          <Right>
            <Wrapper width="full">
              <Box width="full">
                <Slideshow collection={collageArt} ready={collageArt && collageArt.length > 0} />
              </Box>
            </Wrapper>
          </Right>

          <Wrapper width="full" bg="white" style={{ width: '100%' }}>
            <Footer />
          </Wrapper>
        </Bg>
      </ThemeProvider>
    )
  }
}

// const artPropType = PropTypes.shape({
//   id: PropTypes.string,
//   image: PropTypes.shape({
//     id: PropTypes.string,
//     url: PropTypes.string,
//   }),
//   title: PropTypes.string,
// })

// Splash.propTypes = {
//   art: PropTypes.arrayOf(artPropType),
//   siteName: PropTypes.string,
// }
// Splash.defaultProps = {
//   art: null,
// }

export default Splash
